/* eslint-disable no-empty-pattern */
import {createReducer, createActions} from 'reduxsauce'
import Immutable from 'seamless-immutable'

/* ------------- Types and Action Creators ------------- */

const {Types, Creators} = createActions({
  settingsSetProp: ['key', 'value'],
  settingsReset: null,

  countriesRequest: null,
  countriesSuccess: ['countries'],

  subscriptionsRequest: null,
  subscriptionsSuccess: ['subscriptions'],

  focusSubscription: ['focusSubscription'],
  focusSubscriptionReset: null,

  saveBillingAddress: ['presetBillingAddress'],
  clearBillingAddress: null,

  savePaymentMethodRequest: ['data'],
  savePaymentMethodSuccess: ['savePaymentMethodResult'],
  savePaymentMethodFailure: ['savePaymentMethodError'],
  savePaymentMethodSecure: ['savePaymentMethod3DS'],
  savePaymentMethodReset: null,

  savePaymentMethodMollieRequest: ['data'],
  savePaymentMethodMollieSuccess: ['savePaymentMethodMollieResult'],
  savePaymentMethodMollieFailure: ['savePaymentMethodMollieError'],
  savePaymentMethodMollieSecure: ['savePaymentMethodMollie3DS'],
  savePaymentMethodMollieReset: null,

  checkStatusPaymentRequest: ['paymentId'],
  checkStatusPaymentSuccess: ['checkStatusPaymentResult'],
  checkStatusPaymentFailure: ['checkStatusPaymentError'],
  checkStatusPaymentReset: null,

  buySubscriptionRequest: ['data'],
  buySubscriptionSuccess: ['buySubscriptionResult'],
  buySubscriptionFailure: ['buySubscriptionError'],
  buySubscriptionSecure: ['buySubscription3DS'],
  buySubscriptionReset: null,

  updateSubscriptionRequest: ['data'],
  updateSubscriptionSuccess: ['updateSubscriptionResult'],
  updateSubscriptionFailure: ['updateSubscriptionError'],
  updateSubscriptionSecure: ['updateSubscription3DS'],
  updateSubscriptionReset: null,

  deleteScheduledSubscriptionRequest: null,
  deleteScheduledSubscriptionSuccess: ['deleteScheduledSubscriptionResult'],
  deleteScheduledSubscriptionReset: null,

  checkDiscountCodeRequest: ['code'],
  checkDiscountCodeSuccess: ['discountResult'],
  checkDiscountCodeFailure: ['discountError'],
  checkDiscountCodeReset: null,

  saveCompanyInfoRequest: ['data'],
  saveCompanyInfoSuccess: ['saveCompanyInfoResult'],
  saveCompanyInfoReset: null,

  settingsFetchingReset: null,
})

export const SettingsTypes = Types
export default Creators

/* ------------- Initial State ------------- */

export const INITIAL_STATE = Immutable({
  date: [],

  subPage: 'Account',
  period: 'month',
  countries: null,
  subscriptions: null,

  paymentMethod: 'stripe',

  countriesFetching: false,
  subscriptionsFetching: false,
  focusSubscription: null,

  presetBillingAddress: null,

  savePaymentMethodResult: null,
  savePaymentMethodError: null,
  savePaymentMethod3DS: null,
  savePaymentMethodFetching: false,

  savePaymentMethodMollieResult: null,
  savePaymentMethodMollieError: null,
  savePaymentMethodMollie3DS: null,
  savePaymentMethodMollieFetching: false,

  checkStatusPaymentResult: null,
  checkStatusPaymentError: null,
  checkStatusPaymentFetching: false,

  buySubscriptionResult: null,
  buySubscriptionError: null,
  buySubscription3DS: null,
  buySubscriptionFetching: false,

  updateSubscriptionResult: null,
  updateSubscriptionError: null,
  updateSubscription3DS: null,
  updateSubscriptionFetching: false,

  deleteScheduledSubscriptionResult: null,
  deleteScheduledSubscriptionFetching: false,

  discountResult: null,
  discountError: null,
  discountFetching: false,

  saveCompanyInfoResult: null,
  saveCompanyInfoFetching: false,
})

/* ------------- Selectors ------------- */
export const getState = state => state.settings

export const settingsSetProp = (state, {key, value}) => {
  return state.set(key, value)
}

export const settingsReset = state => {
  return state.merge({
    date: [],
  })
}

export const countriesRequest = (state, {}) => {
  return state.merge({countriesFetching: true})
}
export const countriesSuccess = (state, {countries}) => {
  return state.merge({countriesFetching: false, countries})
}

export const subscriptionsRequest = (state, {}) => {
  return state.merge({subscriptionsFetching: true})
}
export const subscriptionsSuccess = (state, {subscriptions}) => {
  return state.merge({subscriptionsFetching: false, subscriptions})
}

export const focusSubscription = (state, {focusSubscription}) => {
  return state.merge({focusSubscription})
}
export const focusSubscriptionReset = (state, {}) => {
  return state.merge({focusSubscription: null})
}

export const saveBillingAddress = (state, {presetBillingAddress}) => {
  return state.merge({presetBillingAddress})
}

export const clearBillingAddress = (state, {}) => {
  return state.merge({presetBillingAddress: null})
}

/**/
export const savePaymentMethodRequest = (state, {data}) => {
  return state.merge({savePaymentMethodFetching: true})
}
export const savePaymentMethodSuccess = (state, {savePaymentMethodResult}) => {
  return state.merge({savePaymentMethodFetching: false, savePaymentMethodResult})
}
export const savePaymentMethodFailure = (state, {savePaymentMethodError}) => {
  return state.merge({savePaymentMethodFetching: false, savePaymentMethodError})
}
export const savePaymentMethodSecure = (state, {savePaymentMethod3DS}) => {
  return state.merge({savePaymentMethodFetching: false, savePaymentMethod3DS})
}
export const savePaymentMethodReset = (state, {}) => {
  return state.merge({
    savePaymentMethodFetching: false,
    savePaymentMethodResult: null,
    savePaymentMethodError: null,
    savePaymentMethod3DS: null,
  })
}
/**/
export const savePaymentMethodMollieRequest = (state, {data}) => {
  return state.merge({savePaymentMethodFetching: true})
}
export const savePaymentMethodMollieSuccess = (state, {savePaymentMethodMollieResult}) => {
  return state.merge({savePaymentMethodFetching: false, savePaymentMethodMollieResult})
}
export const savePaymentMethodMollieFailure = (state, {savePaymentMethodMollieError}) => {
  return state.merge({savePaymentMethodMollieFetching: false, savePaymentMethodMollieError})
}
export const savePaymentMethodMollieSecure = (state, {savePaymentMethodMollie3DS}) => {
  return state.merge({savePaymentMethodMollieFetching: false, savePaymentMethodMollie3DS})
}
export const savePaymentMethodMollieReset = (state, {}) => {
  return state.merge({
    savePaymentMethodMollieFetching: false,
    savePaymentMethodMollieResult: null,
    savePaymentMethodMollieError: null,
    savePaymentMethodMollie3DS: null,
  })
}
/**/

export const checkStatusPaymentRequest = (state, {paymentId}) => {
  return state.merge({checkStatusPaymentFetching: true})
}

export const checkStatusPaymentSuccess = (state, {checkStatusPaymentResult}) => {
  return state.merge({checkStatusPaymentFetching: false, checkStatusPaymentResult})
}

export const checkStatusPaymentFailure = (state, {checkStatusPaymentError}) => {
  return state.merge({checkStatusPaymentFetching: false, checkStatusPaymentError})
}

export const checkStatusPaymentReset = (state, {}) => {
  return state.merge({
    checkStatusPaymentFetching: false,
    checkStatusPaymentResult: null,
    checkStatusPaymentError: null,
  })
}

/**/

export const buySubscriptionRequest = (state, {data}) => {
  return state.merge({buySubscriptionFetching: true})
}
export const buySubscriptionSuccess = (state, {buySubscriptionResult}) => {
  return state.merge({buySubscriptionFetching: false, buySubscriptionResult})
}
export const buySubscriptionFailure = (state, {buySubscriptionError}) => {
  return state.merge({buySubscriptionFetching: false, buySubscriptionError})
}
export const buySubscriptionSecure = (state, {buySubscription3DS}) => {
  return state.merge({buySubscriptionFetching: false, buySubscription3DS})
}
export const buySubscriptionReset = (state, {}) => {
  return state.merge({
    buySubscriptionFetching: false,
    buySubscriptionResult: null,
    buySubscriptionError: null,
    buySubscription3DS: null,
  })
}

export const updateSubscriptionRequest = (state, {data}) => {
  return state.merge({updateSubscriptionFetching: true})
}
export const updateSubscriptionSuccess = (state, {updateSubscriptionResult}) => {
  return state.merge({updateSubscriptionFetching: false, updateSubscriptionResult})
}
export const updateSubscriptionFailure = (state, {updateSubscriptionError}) => {
  return state.merge({updateSubscriptionFetching: false, updateSubscriptionError})
}
export const updateSubscriptionSecure = (state, {updateSubscription3DS}) => {
  return state.merge({updateSubscriptionFetching: false, updateSubscription3DS})
}
export const updateSubscriptionReset = (state, {}) => {
  return state.merge({
    updateSubscriptionFetching: false,
    updateSubscriptionResult: null,
    updateSubscriptionError: null,
    updateSubscription3DS: null,
  })
}

export const deleteScheduledSubscriptionRequest = (state, {}) => {
  return state.merge({deleteScheduledSubscriptionFetching: true})
}

export const deleteScheduledSubscriptionSuccess = (state, {deleteScheduledSubscriptionResult}) => {
  return state.merge({deleteScheduledSubscriptionFetching: false, deleteScheduledSubscriptionResult})
}

export const deleteScheduledSubscriptionReset = (state, {}) => {
  return state.merge({
    deleteScheduledSubscriptionFetching: false,
    deleteScheduledSubscriptionResult: null,
  })
}

export const checkDiscountCodeRequest = (state, {code}) => {
  return state.merge({discountFetching: true})
}
export const checkDiscountCodeSuccess = (state, {discountResult}) => {
  return state.merge({discountFetching: false, discountResult})
}
export const checkDiscountCodeFailure = (state, {discountError}) => {
  return state.merge({discountFetching: false, discountError})
}
export const checkDiscountCodeReset = (state, {}) => {
  return state.merge({discountResult: null, discountError: null})
}

export const saveCompanyInfoRequest = (state, {data}) => {
  return state.merge({saveCompanyInfoFetching: true})
}
export const saveCompanyInfoSuccess = (state, {saveCompanyInfoResult}) => {
  return state.merge({saveCompanyInfoFetching: false, saveCompanyInfoResult})
}
export const saveCompanyInfoReset = (state, {}) => {
  return state.merge({
    saveCompanyInfoFetching: false,
    saveCompanyInfoResult: null,
  })
}

export const settingsFetchingReset = state => {
  return state.merge({
    countriesFetching: false,
    subscriptionsFetching: false,
    savePaymentMethodFetching: false,
    buySubscriptionFetching: false,
    updateSubscriptionFetching: false,
    saveCompanyInfoFetching: false,
    deleteScheduledSubscriptionFetching: false,
    savePaymentMethodMollieFetching: false,
    checkStatusPaymentFetching: false,
  })
}

/* ------------- Hookup Reducers To Types ------------- */
export const reducer = createReducer(INITIAL_STATE, {
  [Types.SETTINGS_SET_PROP]: settingsSetProp,
  [Types.SETTINGS_RESET]: settingsReset,

  [Types.COUNTRIES_REQUEST]: countriesRequest,
  [Types.COUNTRIES_SUCCESS]: countriesSuccess,

  [Types.SUBSCRIPTIONS_REQUEST]: subscriptionsRequest,
  [Types.SUBSCRIPTIONS_SUCCESS]: subscriptionsSuccess,

  [Types.FOCUS_SUBSCRIPTION]: focusSubscription,
  [Types.FOCUS_SUBSCRIPTION_RESET]: focusSubscriptionReset,

  [Types.SAVE_BILLING_ADDRESS]: saveBillingAddress,
  [Types.CLEAR_BILLING_ADDRESS]: clearBillingAddress,

  [Types.SAVE_PAYMENT_METHOD_REQUEST]: savePaymentMethodRequest,
  [Types.SAVE_PAYMENT_METHOD_SUCCESS]: savePaymentMethodSuccess,
  [Types.SAVE_PAYMENT_METHOD_FAILURE]: savePaymentMethodFailure,
  [Types.SAVE_PAYMENT_METHOD_SECURE]: savePaymentMethodSecure,
  [Types.SAVE_PAYMENT_METHOD_RESET]: savePaymentMethodReset,

  [Types.SAVE_PAYMENT_METHOD_MOLLIE_REQUEST]: savePaymentMethodMollieRequest,
  [Types.SAVE_PAYMENT_METHOD_MOLLIE_SUCCESS]: savePaymentMethodMollieSuccess,
  [Types.SAVE_PAYMENT_METHOD_MOLLIE_FAILURE]: savePaymentMethodMollieFailure,
  [Types.SAVE_PAYMENT_METHOD_MOLLIE_SECURE]: savePaymentMethodMollieSecure,
  [Types.SAVE_PAYMENT_METHOD_MOLLIE_RESET]: savePaymentMethodMollieReset,

  [Types.CHECK_STATUS_PAYMENT_REQUEST]: checkStatusPaymentRequest,
  [Types.CHECK_STATUS_PAYMENT_SUCCESS]: checkStatusPaymentSuccess,
  [Types.CHECK_STATUS_PAYMENT_FAILURE]: checkStatusPaymentFailure,
  [Types.CHECK_STATUS_PAYMENT_RESET]: checkStatusPaymentReset,

  [Types.BUY_SUBSCRIPTION_REQUEST]: buySubscriptionRequest,
  [Types.BUY_SUBSCRIPTION_SUCCESS]: buySubscriptionSuccess,
  [Types.BUY_SUBSCRIPTION_FAILURE]: buySubscriptionFailure,
  [Types.BUY_SUBSCRIPTION_SECURE]: buySubscriptionSecure,
  [Types.BUY_SUBSCRIPTION_RESET]: buySubscriptionReset,

  [Types.UPDATE_SUBSCRIPTION_REQUEST]: updateSubscriptionRequest,
  [Types.UPDATE_SUBSCRIPTION_SUCCESS]: updateSubscriptionSuccess,
  [Types.UPDATE_SUBSCRIPTION_FAILURE]: updateSubscriptionFailure,
  [Types.UPDATE_SUBSCRIPTION_SECURE]: updateSubscriptionSecure,
  [Types.UPDATE_SUBSCRIPTION_RESET]: updateSubscriptionReset,

  [Types.SAVE_COMPANY_INFO_REQUEST]: saveCompanyInfoRequest,
  [Types.SAVE_COMPANY_INFO_SUCCESS]: saveCompanyInfoSuccess,
  [Types.SAVE_COMPANY_INFO_RESET]: saveCompanyInfoReset,

  [Types.DELETE_SCHEDULED_SUBSCRIPTION_REQUEST]: deleteScheduledSubscriptionRequest,
  [Types.DELETE_SCHEDULED_SUBSCRIPTION_SUCCESS]: deleteScheduledSubscriptionSuccess,
  [Types.DELETE_SCHEDULED_SUBSCRIPTION_RESET]: deleteScheduledSubscriptionReset,

  [Types.CHECK_DISCOUNT_CODE_REQUEST]: checkDiscountCodeRequest,
  [Types.CHECK_DISCOUNT_CODE_SUCCESS]: checkDiscountCodeSuccess,
  [Types.CHECK_DISCOUNT_CODE_FAILURE]: checkDiscountCodeFailure,
  [Types.CHECK_DISCOUNT_CODE_RESET]: checkDiscountCodeReset,

  [Types.SETTINGS_FETCHING_RESET]: settingsFetchingReset,
})
